import { getRecoil, setRecoil } from "recoil-nexus";
import {
  CouponType,
  PRODUCT_TYPE_EXTENSION,
  PRODUCT_TYPE_RENTAL_DIRECT,
  PRODUCT_TYPE_RENTAL_SMS,
  RequestOrderProudctType,
  orderDetailOptionType,
  orderDetailRealmType,
  paymentRealmType,
} from "../recoil/type";
import { cartPayInfo, cartState } from "../recoil/cart";
import {
  ProductType,
  optionGroupType,
  pickGroupListType,
} from "./StoreController";
import { orderIdGen } from "../utils/idHelper";
import moment from "../utils/moment";
import ApiController from "./ApiController";
import { authState, masterStoreState } from "../recoil/auth";
import { generateBillNumber } from "../utils/util";
import { langState } from "../recoil/lang";
import { useToast } from "./ToastController";
export type OrderHistory = {
  order: Order;
};

export type Order = {
  order_id?: string;
  area_number?: number;
  number?: number;
  is_active?: number;
  is_complete?: number;
  completed_at?: null | string;
  child?: OrderChild[];
};

export type OrderChild = {
  order_seq: number;
  order_status: number;
  ordered_at: string;
  payment_type: number;
  payment_status: number;
  bill_number: string;
  order_nr: null | number;
  order_service: number;
  order_type: number;
  total_amount_org: number;
  discount_amount: number;
  tax: number;
  total_amount_incl: number;
  prepared_at: null | string;
  picked_up_at: null | string;
  cancelled_at: null | string;
  cancel_description: null | string;
  detail: Product[];
};

export type Product = {
  product_id: number;
  product_seq: number;
  set_product_seq: number;
  product_name: string;
  is_set: number;
  has_option: number;
  product_status: number;
  product_price: number;
  product_discount_name: "";
  product_discount_amount: number;
  product_quantity: number;
  product_tax: number;
  product_tax_name: null | string;
  product_tax_rate: string;
  product_total_amount: number;
  request_id: number;
  request_message: string;
  prepared_at: string;
  cancelled_at: string;
  cancel_description: string;
  options: Option[];
  set_options: Product;
};

export type Option = {
  option_id: number;
  option_name: string;
  option_price: number;
};

export type StoreOrderType = {
  address1: string;
  address2: string;
  area_number: number;
  number: number;
  area_name: string;
  name: string;
  store_id: number;
  limit_order_price: number;
  max_delivery_distance: string;
  base_delivery_price: number;
  base_delivery_distance: string;
  surcharge_delivery_distance: number;
  surcharge_delivery_price: number;
  is_self_delivery: number;
  delivery_call_type: number;
  delivery_estimated_time: number;
  delivery_prepare_time: number;
  pickup_name: string;
  pickup_name_en: string;
  store_login_yn: boolean;
  next_open_time: string;
  next_close_time: string;
  store_availability_yn: boolean;
  store_availability: string;
  room_tip: number;
  coupon_list: {
    availble_coupon_list: CouponType[];
    unavailable_coupon_list: CouponType[];
  };
};

export type InputRentalType = {
  option_type_name: string;
  option_name: string;
};

const OrderController = {
  deleteCart: () => {
    setRecoil(cartState, []);
  },

  makeCartProductData: (data: {
    store_id: number;
    product: ProductType;
    category_id: number;
    product_seq: number;
    set_product_seq: number;
    is_set: number;
    optionGroupList: optionGroupType[];
    optionPickList: number[][];
    rentalItem?: InputRentalType;
  }): orderDetailRealmType => {
    /**
     *  사용자가 선택한 옵션을 장바구니에 추가하기 위해
     *  optionPickList를 이용하여 orderDetailOptionType[]으로 변환.
     */
    let price = 0;
    let cartOptionPickList: orderDetailOptionType[] = [];
    for (let i = 0; i < data.optionPickList.length; i++) {
      for (let j = 0; j < data.optionPickList[i].length; j++) {
        let optGroup = data.optionGroupList[i];
        let pickOption = optGroup.option_list[data.optionPickList[i][j]];

        // orderDetailRealmType 의 product_total_amount 을 계산하기 위해 옵션들의 가격 먼저 합산한다.
        price += pickOption.option_price;
        cartOptionPickList.push({
          option_id: Number(pickOption.option_id),
          option_name: pickOption.option_name,
          option_name_en: pickOption.option_name_en,
          option_name_ch: pickOption.option_name_ch,
          option_name_ja: pickOption.option_name_ja,
          option_name_th: pickOption.option_name_th,
          option_name_es: pickOption.option_name_es,
          option_name_fr: pickOption.option_name_fr,
          option_name_ru: pickOption.option_name_ru,
          option_name_de: pickOption.option_name_de,
          option_name_translate_id: pickOption.option_name_translate_id,
          option_type_id: optGroup.option_type_id,
          option_type_name: optGroup.option_type_name,
          option_type_name_en: optGroup.option_type_name_en,
          option_type_name_ch: optGroup.option_type_name_ch,
          option_type_name_ja: optGroup.option_type_name_ja,
          option_type_name_th: optGroup.option_type_name_th,
          option_type_name_es: optGroup.option_type_name_es,
          option_type_name_fr: optGroup.option_type_name_fr,
          option_type_name_ru: optGroup.option_type_name_ru,
          option_type_name_de: optGroup.option_type_name_de,
          option_type_name_translate_id: optGroup.option_type_name_translate_id,
          option_price: pickOption.option_price,
          created_at: new Date(),
        });
      }
    }
    // if (
    //   (data.product.prd_type === PRODUCT_TYPE_RENTAL_DIRECT ||
    //     data.product.prd_type === PRODUCT_TYPE_RENTAL_SMS) &&
    //   data.rentalItem
    // ) {
    //   cartOptionPickList.push({
    //     option_id: Number(
    //       data.rentalItem.option_type_name.slice(0, 2) +
    //         data.rentalItem.option_type_name.slice(3, 5) +
    //         (data.rentalItem.option_name === "즉시대여"
    //           ? "30"
    //           : data.rentalItem.option_name.slice(0, 2))
    //     ),
    //     option_name: data.rentalItem.option_name,
    //     option_name_en: data.rentalItem.option_name,
    //     option_name_ch: data.rentalItem.option_name,
    //     option_name_ja: data.rentalItem.option_name,
    //     option_name_th: data.rentalItem.option_name,
    //     option_name_es: data.rentalItem.option_name,
    //     option_name_fr: data.rentalItem.option_name,
    //     option_name_ru: data.rentalItem.option_name,
    //     option_name_de: data.rentalItem.option_name,
    //     option_name_translate_id: 0,
    //     option_type_id: 0,
    //     option_type_name: data.rentalItem.option_type_name,
    //     option_type_name_en: data.rentalItem.option_type_name,
    //     option_type_name_ch: data.rentalItem.option_type_name,
    //     option_type_name_ja: data.rentalItem.option_type_name,
    //     option_type_name_th: data.rentalItem.option_type_name,
    //     option_type_name_es: data.rentalItem.option_type_name,
    //     option_type_name_fr: data.rentalItem.option_type_name,
    //     option_type_name_ru: data.rentalItem.option_type_name,
    //     option_type_name_de: data.rentalItem.option_type_name,
    //     option_type_name_translate_id: 0,
    //     option_price: 0,
    //     created_at: new Date(),
    //   });
    // }

    /**
     *  장바구니에 추가할 상품을 orderDetailRealmType 타입으로 변환.
     *  앞서 orderDetailOptionType[] 로 변환한 선택 옵션들을 options속성에 저장.
     */
    let tempCartItem: orderDetailRealmType = {
      store_id: data.store_id,
      product_id: data.product.prd_id,
      category_id: data.category_id,
      product_seq: data.product_seq,
      set_product_seq: data.set_product_seq,
      // set_prd_type_seq: data.set_prd_type_seq,
      // set_prd_type_id: data.set_prd_type_id,
      // set_prd_type_name: data.set_prd_type_name,
      product_name: data.product.prd_name,
      product_name_en: data.product.prd_name_en,
      product_name_ch: data.product.prd_name_ch,
      product_name_ja: data.product.prd_name_ja,
      product_name_th: data.product.prd_name_th,
      product_name_es: data.product.prd_name_es,
      product_name_fr: data.product.prd_name_fr,
      product_name_ru: data.product.prd_name_ru,
      product_name_de: data.product.prd_name_de,
      product_name_translate_id: data.product.prd_name_translate_id,
      is_set: data.is_set,
      has_option: cartOptionPickList?.length ? 1 : 0,
      product_status: 0,
      prdouct_discount_percentage: data.product.prd_discount_percentage,
      product_org_price: parseInt(data.product.prd_org_price),
      product_price: parseInt(data.product.prd_base_price),
      product_discount_amount:
        parseInt(data.product.prd_org_price) -
        parseInt(data.product.prd_base_price),
      product_discount_name: "상품할인",
      product_quantity: 1,
      product_total_amount:
        parseInt(data.product.prd_base_price.toString()) + price,
      product_type: data.product.prd_type,
      confirm_type: data.product.confirm_type,
      product_tax_name: "",
      product_tax_rate: "0",
      options: cartOptionPickList,
      set_product: [],
      ...(data.product.hour_extension
        ? { hour_extension: data.product.hour_extension }
        : {}),
      // products: [],
    };

    return tempCartItem;
  },

  /**
   * * 기능: 장바구니에 상품을 추가한다.
   *
   * @param {productType} product - 추가할 상품
   * @param {number} categoryId - 카테고리
   * @param {number[][]} optionPickList - 선택한 옵션 리스트
   * @param {any} callback - 장바구니 추가 후 콜백함수
   */
  addCart: (
    store_id: number,
    product: ProductType,
    categoryId: number,
    optionGroupList: optionGroupType[],
    optionPickList: number[][],
    showToast: (message: string, type?: string, second?: number) => void,
    rentalItem?: InputRentalType,
    callback?: any
  ) => {
    const additionalOrderData = getRecoil(cartState);
    console.log("장바구니", additionalOrderData.length);

    if (
      additionalOrderData.length > 0 &&
      additionalOrderData[0].product_type === PRODUCT_TYPE_EXTENSION &&
      product.prd_type === 2
    ) {
      showToast("퇴실 연박 상품은 중복 담기 불가", "error");
      return;
    }

    if (
      additionalOrderData.length > 0 &&
      (additionalOrderData[0].product_type !== product.prd_type ||
        additionalOrderData[0].confirm_type !== product.confirm_type)
    ) {
      showToast("함께 담을 수 없는 상품이에요", "error");
      return;
    }

    let tempCartItem = OrderController.makeCartProductData({
      store_id,
      product,
      category_id: categoryId,
      product_seq: additionalOrderData.length,
      set_product_seq: 0,
      is_set: 0,
      optionGroupList: optionGroupList,
      optionPickList: optionPickList,
      rentalItem:
        (product.prd_type === PRODUCT_TYPE_RENTAL_DIRECT ||
          product.prd_type === PRODUCT_TYPE_RENTAL_SMS) &&
        rentalItem
          ? rentalItem
          : undefined,
    });

    /**
     * - 장바구니에 추가할 상품이 이미 장바구니에 존재하면 수량과 가격만 수정.
     * - 장바구니에 존재하지 않을경우 상품을 추가
     */
    let cartProductIndex = OrderController.checkExistCartMenu(
      additionalOrderData,
      tempCartItem
    );
    console.log("cartProductIndex==>", cartProductIndex);
    if (cartProductIndex >= 0) {
      let newCart = [...additionalOrderData];
      let orgProduct = { ...additionalOrderData[cartProductIndex] };

      newCart[cartProductIndex] = {
        ...newCart[cartProductIndex],
        product_quantity: orgProduct.product_quantity + 1,
        product_total_amount:
          orgProduct.product_quantity === 0
            ? 0
            : (orgProduct.product_total_amount *
                (orgProduct.product_quantity + 1)) /
              orgProduct.product_quantity,
        product_discount_amount:
          orgProduct.product_quantity === 0
            ? 0
            : (orgProduct.product_discount_amount *
                (orgProduct.product_quantity + 1)) /
              orgProduct.product_quantity,
      };

      console.log(JSON.stringify(newCart));
      setRecoil(cartState, newCart);
      // OrderController.setCartRecoil(newCart);
    } else {
      let newCart = [...additionalOrderData];
      newCart.push(tempCartItem);
      setRecoil(cartState, newCart);
    }

    if (callback) {
      callback();
    }
  },

  /**
   * * 기능: 장바구니에 상품을 추가한다.
   *
   * @param {productType} product - 추가할 상품
   * @param {number} categoryId - 카테고리
   * @param {number[][]} optionPickList - 선택한 옵션 리스트
   * @param {any} callback - 장바구니 추가 후 콜백함수
   */
  addSetCart: (
    store_id: number,
    product: ProductType,
    categoryId: number,
    pickSetProductList: pickGroupListType[]
  ) => {
    const additionalOrderData = getRecoil(cartState);
    const setProduct = OrderController.makeCartProductData({
      store_id,
      product,
      category_id: categoryId,
      product_seq: additionalOrderData.length,
      set_product_seq: 0,
      is_set: 1,
      optionGroupList: [],
      optionPickList: [],
    });

    let price = setProduct.product_total_amount;
    for (let j = 0; j < pickSetProductList.length; j++) {
      const pickProductGroup = pickSetProductList[j];

      for (let k = 0; k < pickProductGroup.pick.length; k++) {
        const pickProduct = pickProductGroup.pick[k];
        price += pickProduct.prd_price;
        for (let l = 0; l < pickProduct.pick.length; l++) {
          for (let z = 0; z < pickProduct.pick[l].length; z++) {
            const pickOption =
              pickProduct.option_group_list[l].option_list[
                pickProduct.pick[l][z]
              ];
            console.log(
              pickProduct.option_group_list[l].option_type_name,
              "==>>",
              pickProduct.option_group_list[l].option_list[z].option_name,
              "=======>>>>>>",
              pickOption.option_price
            );
            price += pickOption.option_price;
          }
        }
      }
    }

    setProduct.product_total_amount = price;
    setProduct.set_product = [
      ...pickSetProductList.filter((obj) => {
        return obj.pick.length > 0;
      }),
    ];

    let newCart = [...additionalOrderData];
    newCart.push(setProduct);
    setRecoil(cartState, newCart);

    return setProduct;
  },

  /**
   * * 기능: 장바구니에 동일한 상품, 동일한 옵션이 존재할 경우 해당 인덱스를 반환
   *
   * @param sourceMenu 기존 cart
   * @param targetMenu cart에 추가할 상품
   * @returns
   */
  checkExistCartMenu: (
    sourceMenu?: orderDetailRealmType[],
    targetMenu?: orderDetailRealmType
  ): number => {
    let checkExists = -1;
    if (sourceMenu === undefined || targetMenu === undefined) {
      return checkExists;
    }

    for (let i = 0; i < sourceMenu.length; i++) {
      let cartPrd = sourceMenu[i];

      if (
        cartPrd.product_id === targetMenu.product_id &&
        cartPrd.store_id === targetMenu.store_id
      ) {
        //기존의 상품중 prd_id 가 같은 상품을 탐색한다.

        let cartPrdOpt = cartPrd.options ? cartPrd.options : [];
        let itemForCartOpt = targetMenu.options ? targetMenu.options : [];

        if (cartPrdOpt.length !== itemForCartOpt.length) {
          console.log("개수가 다르면 일치한 메뉴가 아니다");
          //개수가 다르면 일치한 메뉴가 아니다
          continue;
        }

        let objPrdOpt: any = {};
        for (let j = 0; j < cartPrdOpt.length; j++) {
          objPrdOpt[String(cartPrdOpt[j].option_id)] = true;
        }

        let optflag = true; //옵션 일치 여부
        for (let j = 0; j < itemForCartOpt.length; j++) {
          if (!objPrdOpt.hasOwnProperty(String(itemForCartOpt[j].option_id))) {
            console.log("옵션 일치 여부");
            optflag = false;
            break;
          }
        }

        if (optflag === true) {
          //product_id 와 options가 일치한 경우 set option 일치 여부를 판단한다.
          if (cartPrd.is_set === 1 && targetMenu.is_set === 1) {
          } else if (cartPrd.is_set === 0 && targetMenu.is_set === 0) {
          } else {
            continue;
          }

          checkExists = i;
          break;
        }
      }
    }

    return checkExists;
  },

  /**
   *
   * * 기능: 장바구니에 담긴 상품의 수량을 증감, 가격 수정
   *
   *
   * @param index
   * @param addFlag true-> 1증가 false-> 1감소
   */
  updateCartRecoilproductQuantityByIndex: (
    cartProductIndex: number,
    addFlag: boolean,
    showToast: (message: string, type?: string, second?: number) => void
  ) => {
    const additionalOrderData = getRecoil(cartState);

    if (cartProductIndex >= additionalOrderData.length) {
      console.log(
        "OrderController.updateCartRecoilproductQuantity index error"
      );
      return;
    }

    //퇴실 연박상품은 증가 X
    if (addFlag && additionalOrderData[cartProductIndex].product_type === 2) {
      showToast("퇴실 상품은 증가 불가");
      return;
    }

    let newCart = [...additionalOrderData];
    let orgProduct = { ...additionalOrderData[cartProductIndex] };

    if (addFlag) {
      newCart[cartProductIndex] = {
        ...newCart[cartProductIndex],
        product_quantity: orgProduct.product_quantity + 1,
        product_total_amount:
          (orgProduct.product_total_amount *
            (orgProduct.product_quantity + 1)) /
          orgProduct.product_quantity,
        product_discount_amount:
          (orgProduct.product_discount_amount *
            (orgProduct.product_quantity + 1)) /
          orgProduct.product_quantity,
      };
    } else {
      if (orgProduct.product_quantity <= 1) {
        newCart.splice(cartProductIndex, 1);
      } else {
        newCart[cartProductIndex] = {
          ...newCart[cartProductIndex],
          product_quantity: orgProduct.product_quantity - 1,
          product_total_amount:
            (orgProduct.product_total_amount *
              (orgProduct.product_quantity - 1)) /
            orgProduct.product_quantity,
          product_discount_amount:
            (orgProduct.product_discount_amount *
              (orgProduct.product_quantity - 1)) /
            orgProduct.product_quantity,
        };
      }
    }

    setRecoil(cartState, newCart);
  },

  /**
   *
   * * 기능: 장바구니에 담긴 상품을 제거
   *
   * @param cartProductIndex
   * @param addFlag
   * @returns
   */
  deleteCartRecoilproductQuantityByIndex: (cartProductIndex: number) => {
    // const additionalOrderData = OrderController.getCartRecoil();
    const additionalOrderData = getRecoil(cartState);
    if (cartProductIndex >= additionalOrderData.length) {
      console.log(
        "OrderController.deleteCartRecoilproductQuantityByIndex index error"
      );
      return;
    }

    let newCart = [...additionalOrderData];

    newCart.splice(cartProductIndex, 1);

    // OrderController.setCartRecoil(newCart);
    setRecoil(cartState, newCart);
  },

  sendOrder: async (
    cart: orderDetailRealmType[],
    priceInfo: cartPayInfo,
    payment: paymentRealmType,
    storeRequestText: string,
    deliveryInfo: {
      address1: string;
      address2: string;
      area_number: number;
      number: number;
      area_name: string;
      name: string;
      store_id: number;
      limit_order_price: number;
      is_self_delivery: number;
      base_delivery_price: number;
      pickup_name: string;
      pickup_name_en: string;
      room_tip: number;
      // status: number;
    },
    discount: {
      discountAmount: number;
      storeDiscountAmount: number;
      hqDiscountAmount: number;
      storeDiscountList: { description: string; discount: number }[];
      hqDiscountList: { description: string; discount: number }[];
      couponList: (CouponType & {
        store_discount_amount: number;
        com_discount_amount: number;
      })[];
    },
    number?: string,
    email?: string
  ): Promise<any> => {
    const order_date = moment().toDate();
    const order_id = orderIdGen(new Date());
    const storeName = getRecoil(authState).store_list.find(
      (store) => store.store_id === cart[0].store_id
    );
    const master = getRecoil(masterStoreState);

    let order_category = 0; //주문 유형(0: 일반, 1: X, 2: 퇴실연장, 3.시간지정-직접배달, 4.시간지정-카톡/메일알림)
    if (cart[0].product_type === 3) {
      order_category = 3;
    } else if (cart[0].product_type === 4) {
      order_category = 4;
    }

    let order_status = 0;
    if (cart[0].product_type === 3) {
      order_status = 0;
    } else if (cart[0].product_type === 4) {
      order_status = 0;
    }

    if (master) {
      let request_data: RequestOrderProudctType = {
        store_id: cart[0].store_id,
        store_name: storeName ? storeName.store_name : "???",
        order_id: order_id,
        number: deliveryInfo.number,
        area_number: deliveryInfo.area_number,
        parent_store_id: master.store_id,
        parent_store_name: master.store_name,
        is_active: 1, //웨이팅 관련
        order: {
          order_seq: 0,
          order_status, //주문상태(0: 주문대기, 1: 준비중, 2: 조리완료, 3: 서빙완료, 4: 주문취소, 5: 주문완료, 6: 배달시작, 7:배달완료)
          order_category, //주문 유형(0: 일반, 1: X, 2: 퇴실연장, 3.시간지정-직접배달, 4.시간지정-카톡/메일알림)
          ordered_at: moment(order_date).format("YYYY-MM-DD HH:mm:ss"),
          payment_type: 0, //0: 선불, 1:후불
          payment_status: 1, //0: 미결제, 1: 결제 완료, 2: 결제 취소  3:1/n결제 진행중
          bill_number: generateBillNumber(),
          payment_method: 0, //VAN결제
          order_nr: null,
          order_type: 2, //1: 매장, 2: 배달, 3: 포장, 4: 직원호출
          order_service: 8, //1: 포스, 2: 스루, 3: 배민, 4: 쿠팡, 5: 요기요, 6: 키오스크, 7:테이블오더, 8:knock
          total_amount_org: priceInfo.total_amount_incl,
          discount_amount: discount.discountAmount,
          prd_discount_amount: priceInfo.discount_amount,
          store_discount_amount: discount.storeDiscountAmount,
          com_discount_amount: discount.hqDiscountAmount,
          tax: priceInfo.tax,
          total_amount_incl: payment.amount ? payment.amount : 0,
          delivery_tip: deliveryInfo.base_delivery_price,
          room_tip: deliveryInfo.room_tip,
          confirm_type: cart[0].confirm_type,
          delivery_address:
            deliveryInfo.address1 +
            " " +
            deliveryInfo.address2 +
            " " +
            deliveryInfo.area_name +
            " " +
            deliveryInfo.name,
          delivery_address_detail:
            deliveryInfo.area_name + " " + deliveryInfo.name,
          delivery_type: deliveryInfo.is_self_delivery,
          pickup_name: deliveryInfo.pickup_name,
          pickup_name_en: deliveryInfo.pickup_name_en,
          pickup_type: 3, //1: drive thru, 2: walk thru , 3: delivery, 4: hall
          inquiry: storeRequestText,
          lang: getRecoil(langState),
          order_check_type: number ? 1 : email ? 2 : undefined,
          phone_number: number ? number : undefined,
          email: email ? email : undefined,
          products: cart.map((e: orderDetailRealmType, i: number) => {
            return {
              //TODO category_id 추가
              product_id: e.product_id,
              category_id: e.category_id,
              // product_name: e.product_name,
              // product_name_en: e.product_name_en,
              // product_name_ch: e.product_name_ch,
              // product_name_ja: e.product_name_ja,
              // product_name_th: e.product_name_th,
              product_name_translate_id: e.product_name_translate_id,
              has_option: e.options?.length ? 1 : 0,
              is_set: e.is_set === undefined ? 0 : e.is_set,
              product_seq: i,
              product_type: e.product_type,
              product_price: e.product_price,
              product_org_price: e.product_org_price,
              set_prd_type_seq: 0,
              set_product_seq: 0,
              set_prd_type_id: 0,
              set_prd_type_name_translate_id: null,
              // set_prd_type_name: "",
              // set_prd_type_name_en: "",
              // set_prd_type_name_ch: "",
              // set_prd_type_name_ja: "",
              // set_prd_type_name_th: "",
              // set_prd_type_name_es: "",
              // set_prd_type_name_fr: "",
              // set_prd_type_name_ru: "",
              // set_prd_type_name_de: "",
              product_status: 0,
              product_discount_name: e.product_discount_name,
              product_discount_amount: e.product_discount_amount,
              product_quantity: e.product_quantity,
              product_tax: 0,
              product_tax_name: null,
              product_tax_rate: "0.00",
              product_total_amount: e.product_total_amount,
              request_id: null,
              request_message: null,
              options: e.options?.length
                ? e.options?.map((e: any) => {
                    return {
                      option_id: e.option_id,
                      // option_name: e.option_name,
                      // option_name_en: e.option_name_en,
                      // option_name_ch: e.option_name_ch,
                      // option_name_ja: e.option_name_ja,
                      // option_name_th: e.option_name_th,
                      option_name_translate_id: e.option_name_translate_id,
                      option_price: e.option_price,
                      option_type_id: e.option_type_id,
                      // option_type_name: e.option_type_name,
                      // option_type_name_en: e.option_type_name_en,
                      // option_type_name_ch: e.option_type_name_ch,
                      // option_type_name_ja: e.option_type_name_ja,
                      // option_type_name_th: e.option_type_name_th,
                      option_type_name_translate_id:
                        e.option_type_name_translate_id,
                    };
                  })
                : [],
              products: e.set_product, //TODO 세트 옵션 추가
            };
          }),
        },
        payments: [
          {
            ...payment,
            order_seq: 0,
            store_id: cart[0].store_id,
            order_id: order_id,
          },
        ],
        coupons: discount.couponList,
      };

      // 1. [메뉴주문] /order/products 호출
      let res = await ApiController.order.products(request_data);
      return res;
    }
  },

  sendCheckoutOrder: async (
    cart: orderDetailRealmType[],
    priceInfo: cartPayInfo,
    payment: paymentRealmType,
    deliveryInfo: {
      address1: string;
      address2: string;
      area_number: number;
      number: number;
      area_name: string;
      name: string;
      store_id: number;
      limit_order_price: number;
      is_self_delivery: number;
      base_delivery_price: number;
      pickup_name: string;
      pickup_name_en: string;
      room_tip: number;
      // status: number;
    }
  ): Promise<any> => {
    const order_date = moment().toDate();
    const order_id = orderIdGen(new Date());
    const storeName = getRecoil(authState).store_list.find(
      (store) => store.store_id === cart[0].store_id
    );
    const master = getRecoil(masterStoreState);

    if (master) {
      let request_data: RequestOrderProudctType = {
        store_id: cart[0].store_id,
        store_name: storeName ? storeName.store_name : "???",
        order_id: order_id,
        number: deliveryInfo.number,
        area_number: deliveryInfo.area_number,
        parent_store_id: master.store_id,
        parent_store_name: master.store_name,
        is_active: 1, //웨이팅 관련
        order: {
          order_seq: 0,
          order_status: 5, //주문상태(0: 주문대기, 1: 준비중, 2: 조리완료, 3: 서빙완료, 4: 주문취소, 5: 주문완료, 6: 배달시작, 7:배달완료)
          order_category: 2, //주문 유형(0: 일반, 1: 시간지정, 2: 퇴실 연장)
          ordered_at: moment(order_date).format("YYYY-MM-DD HH:mm:ss"),
          payment_type: 0, //0: 선불, 1:후불
          payment_status: 1, //0: 미결제, 1: 결제 완료, 2: 결제 취소  3:1/n결제 진행중
          bill_number: generateBillNumber(),
          payment_method: 0, //VAN결제
          order_nr: null,
          order_type: 1, //1: 매장, 2: 배달, 3: 포장, 4: 직원호출
          order_service: 8, //1: 포스, 2: 스루, 3: 배민, 4: 쿠팡, 5: 요기요, 6: 키오스크, 7:테이블오더, 8:knock
          total_amount_org: priceInfo.total_amount_incl,
          discount_amount: 0,
          prd_discount_amount: priceInfo.discount_amount,
          store_discount_amount: 0,
          com_discount_amount: 0,
          tax: priceInfo.tax,
          total_amount_incl: payment.amount ? payment.amount : 0,
          delivery_tip: 0,
          room_tip: 0,
          confirm_type: cart[0].confirm_type,
          delivery_address:
            deliveryInfo.address1 +
            " " +
            deliveryInfo.address2 +
            " " +
            deliveryInfo.area_name +
            " " +
            deliveryInfo.name,
          delivery_address_detail:
            deliveryInfo.area_name + " " + deliveryInfo.name,
          delivery_type: 0,
          pickup_name: "",
          pickup_name_en: "",
          pickup_type: 3, //1: drive thru, 2: walk thru , 3: delivery, 4: hall
          inquiry: "",
          lang: getRecoil(langState),
          products: cart.map((e: orderDetailRealmType, i: number) => {
            return {
              //TODO category_id 추가
              product_id: e.product_id,
              category_id: e.category_id,
              // product_name: e.product_name,
              // product_name_en: e.product_name_en,
              // product_name_ch: e.product_name_ch,
              // product_name_ja: e.product_name_ja,
              // product_name_th: e.product_name_th,
              product_name_translate_id: e.product_name_translate_id,
              has_option: e.options?.length ? 1 : 0,
              is_set: e.is_set === undefined ? 0 : e.is_set,
              product_seq: i,
              product_type: e.product_type,
              product_price: e.product_price,
              product_org_price: e.product_org_price,
              set_prd_type_seq: 0,
              set_product_seq: 0,
              set_prd_type_id: 0,
              set_prd_type_name_translate_id: null,
              // set_prd_type_name: "",
              // set_prd_type_name_en: "",
              // set_prd_type_name_ch: "",
              // set_prd_type_name_ja: "",
              // set_prd_type_name_th: "",
              // set_prd_type_name_es: "",
              // set_prd_type_name_fr: "",
              // set_prd_type_name_ru: "",
              // set_prd_type_name_de: "",
              product_status: 0,
              product_discount_name: e.product_discount_name,
              product_discount_amount: e.product_discount_amount,
              product_quantity: e.product_quantity,
              product_tax: 0,
              product_tax_name: null,
              product_tax_rate: "0.00",
              product_total_amount: e.product_total_amount,
              request_id: null,
              request_message: null,
              ...(e.hour_extension ? { hour_extension: e.hour_extension } : {}),
              options: e.options?.length
                ? e.options?.map((e) => {
                    return {
                      option_id: e.option_id,
                      // option_name: e.option_name,
                      // option_name_en: e.option_name_en,
                      // option_name_ch: e.option_name_ch,
                      // option_name_ja: e.option_name_ja,
                      // option_name_th: e.option_name_th,
                      option_name_translate_id: e.option_name_translate_id,
                      option_price: e.option_price,
                      option_type_id: e.option_type_id,
                      // option_type_name: e.option_type_name,
                      // option_type_name_en: e.option_type_name_en,
                      // option_type_name_ch: e.option_type_name_ch,
                      // option_type_name_ja: e.option_type_name_ja,
                      // option_type_name_th: e.option_type_name_th,
                      option_type_name_translate_id:
                        e.option_type_name_translate_id,
                    };
                  })
                : [],
              products: e.set_product, //TODO 세트 옵션 추가
            };
          }),
        },
        payments: [
          {
            ...payment,
            order_seq: 0,
            store_id: cart[0].store_id,
            order_id: order_id,
          },
        ],
        // coupons: discount.couponList,
        coupons: [],
      };

      // 1. [메뉴주문] /order/products 호출
      let res = await ApiController.order.products(request_data);
      return res;
    }
  },
};

export default OrderController;
